import { UpdateControlMetadata } from '../validators/helpers';

export function ReadonlyControl(target: any, propertyKey: string) {
  UpdateControlMetadata(target, propertyKey, { readonly: true });
}
